module.exports = __webpack_public_path__ + "static/media/pos_image.61bfe1e8.svg";